<template>
  <div class="list-item">
    <Checkbox :name="item.id" @click="handleCheckBoxClicked(item.id)">
      <div class="card-item">
        <img :src="item.mainImage" />
        <div class="card-right">
          <div class="right-title">{{ item.titleName }}</div>
          <div class="right-tag-distance-address">
            <div class="tag" v-if="item.tagName">{{ item.tagName }}</div>
            <div class="distance">{{ item.distance }}km</div>
            <div class="line">|</div>
            <div class="distance">{{ item.address.city }}</div>
          </div>
          <!-- <div class="open-time">开放时间：{{ item.openingHours }}</div> -->
        </div>
      </div>
    </Checkbox>
  </div>
</template>

<script>
import { Checkbox } from 'vant'
import { mapMutations } from 'vuex'

export default {
  name: 'listItem',
  components: { Checkbox },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    handleCheckBoxClicked: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
.list-item {
  padding: 0.2rem 0;
  background: #fff;
  .card-item {
    display: flex;
    & > img {
      width: 1.8rem;
      height: 1.8rem;
      border-radius: 0.14rem;
      margin-right: 0.2rem;
    }
    .card-right {
      flex: 1;
      .right-title {
        height: 0.72rem;
        font-size: 0.34rem;
        color: #333;
        font-weight: 600;
        margin-bottom: 0.2rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      .right-tag-distance-address {
        display: flex;
        align-items: center;
        margin-bottom: 0.04rem;
        .tag {
          height: 0.4rem;
          padding: 0 0.1rem;
          line-height: 0.4rem;
          background: #ffdaa2;
          border-radius: 0.08rem;
          font-size: 0.22rem;
          color: #a54400;
          margin-right: 0.1rem;
        }
        .distance {
          font-size: 0.26rem;
          color: #666;
          font-weight: 400;
        }
        .line {
          padding: 0 0.2rem;
          font-size: 0.26rem;
          color: #ccc;
          font-weight: 400;
        }
        .address {
          font-size: 0.26rem;
          color: #666;
          font-weight: 400;
        }
      }
      .open-time {
        font-size: 0.26rem;
        color: #666;
        font-weight: 400;
      }
    }
  }
}
</style>